import { Component, Input, inject } from '@angular/core';
import { Pin, PinAddress, SavedParcel, SavedPin } from '@models/teranet';
import { Dispatch } from '@ngxs-labs/dispatch-decorator';
import { SalePinActions, SalePinState } from '@state/sale_pins';
import { getPinAddressString } from '@core/util/pins';
import { SelectSnapshot } from '@ngxs-labs/select-snapshot';
import { MatDialog } from '@angular/material/dialog';
import {
	PdfModalComponent,
	PdfModalData,
} from '@components/pdf-modal/pdf-modal.component';
import { PurchaseStateType } from '@state/utils/models';
import { ICON } from '@core/util/icon';
import { TestHooks } from './lots.hooks';
import { DrawerService } from 'src/app/ui/drawer/drawer.service';

@Component({
	selector: 'app-teranet-map-lots',
	templateUrl: './lots.component.html',
	standalone: false,
})
export class TeranetMapLotsComponent {
	testHooks = TestHooks;
	ICON = ICON;
	public selectedLots: string[] = [];
	public purchaseStates = PurchaseStateType;
	public includeDeleted = true;

	@SelectSnapshot(SalePinState.getParcelPurchaseState) parcelPurchaseStates: {
		[pin: string]: { state: PurchaseStateType; error?: string };
	};

	@Input() lots: SavedPin[] = [];

	drawerService = inject(DrawerService);

	constructor(private dialog: MatDialog) {}

	getAddressString = (address: PinAddress) => getPinAddressString(address);

	toggleSelectLot = (pin: string) => {
		if (this.selectedLots.includes(pin)) {
			this.selectedLots = this.selectedLots.filter((x) => x !== pin);
		} else {
			this.selectedLots.push(pin);
		}
	};

	selectedLot = (pin: string) => this.selectedLots.includes(pin);

	toggleAllLots = () => {
		if (this.lots.length === this.selectedLots.length) {
			this.selectedLots = [];
		} else {
			this.selectedLots = this.lots
				.filter((x) => !x?.parcels || x.parcels.length === 0)
				.map((x) => x.pin);
		}
	};

	allSelected = () => {
		if (this.selectedLots.length === 0) {
			return false;
		}
		return (
			this.lots.filter((x) => !x?.parcels || x.parcels.length === 0).length ===
			this.selectedLots.length
		);
	};

	@Dispatch()
	purchasePinParcel = (pin: Pin, include_deleted: boolean) =>
		new SalePinActions.PurchaseParcel({ pin, include_deleted, parent: false });

	purchaseSelected = () => {
		const _pins = this.lots.filter((x) => this.selectedLots.includes(x.pin));
		_pins.forEach((pin) => {
			this.purchasePinParcel(pin, this.includeDeleted);
		});
		this.selectedLots = [];
	};

	openPDF = (parcel: SavedParcel, pin: string) => {
		const data: PdfModalData = {
			googleSrcUrl: parcel.uploaded_document_path,
			fileName: `PIN_${pin}`,
		};
		this.drawerService.openDrawer(PdfModalComponent, {
			data,
			title: data.fileName,
			noStyle: true,
		});
	};

	toggleIncludeDeleted($event: boolean) {
		this.includeDeleted = $event;
	}
}
